module.exports = __webpack_public_path__ + "img/jt1.90bd33b9.png";